export function RadioCheckedBlackIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_590_35467)">
        <rect width="18" height="18" rx="9" fill="#101828" />
        <path d="M13.1658 5.875L7.43668 11.6042L4.83252 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_590_35467">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

RadioCheckedBlackIcon.displayName = 'RadioCheckedBlackIcon';
